import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { useCommunicationModal } from '../../model/useCommunicationModal';
import { CommunicationModalView } from '../CommunicationModalView';

export const CommunicationModal = () => {
    const { communication, isOpen, onClose, onAction, completeLeaving } = useCommunicationModal();

    if (!communication) {
        return null;
    }

    const handleClose = () => {
        logEventString('CommunicationModal.CloseButtonClick', 'true', {
            communication_id: communication.id,
        });

        onClose();
    };

    const handleButtonClick = () => {
        logEventString('CommunicationModal.ActionButtonClick', 'true', {
            communication_id: communication.id,
        });

        onAction();
    };

    return (
        <CommunicationModalView
            communication={communication}
            isOpen={isOpen}
            onClose={handleClose}
            onAction={handleButtonClick}
            onCloseComplete={completeLeaving}
        />
    );
};
